import { useFormContext } from 'react-hook-form';
import React, {Fragment} from "react";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import {
    ArrayInput,
    BooleanInput, Button,
    DateInput, FormTab,
    ImageField,
    FileField,
    ImageInput,
    FileInput,
    NumberInput, SaveButton,
    SelectInput, SimpleFormIterator,
    AutocompleteInput,
    TextInput, Toolbar, required,
    useGetList,
    useSourceContext
} from "react-admin";
import familyRelationshipData from "./familyRelationshipData";
import moment from "moment";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { RichTextInput } from "ra-input-rich-text";
import { withStyles } from "@mui/styles";
import BackIcon from "@mui/icons-material/ArrowBack";
import NextIcon from "@mui/icons-material/ArrowForward";
import {useNavigate, useLocation} from 'react-router-dom';
import EthiopianDateInput from "../uiComponents/ethiopianDateInput";

const toolbarStyles = {
    // toolbar: {
    //     display: 'flex',
    //     justifyContent: 'space-between',
    // },
};

export const CustomToolbar = withStyles(toolbarStyles)(props => {
        const parent = props.record&&props.record.id?props.record.id:"create";
        const navigate = useNavigate();
        const location = useLocation();
        const regex = '[^/]+(?=/$|$)'
        const tab =( +location.pathname.match(regex)[0])||0;
        return <Toolbar {...props}>

                {!!tab&&<Button
                    variant="contained"
                    color="secondary"
                    label="Prev" onClick={() => {

                    navigate(tab - 1 ? (tab - 1).toString() : `../${parent}`)
                }} startIcon={<BackIcon />}  />}
                {tab<(props.tabs-1)&&<Button

                    variant="contained"
                    color="primary"

                    label="Next" onClick={() => {

                    navigate(tab ? (tab + 1).toString() : `${parent}/1`)
                }} endIcon={<NextIcon />} />}

            {((props.record&&props.record.id)||tab===(props.tabs-1))&&<SaveButton/>}
            {/*<DeleteButton undoable={false} />*/}
        </Toolbar>
    })
;


export  function formatPic(value) {
    if (!value ||  typeof value === "string") { // Value is null or the url string from the backend, wrap it in an object so the form input can handle it
        return { src: value };
    } else {  // Else a new image is selected which results in a value object already having a preview link under the url key
        return value;
    }
}



export const FamilyForm = ({scopedFormData, ...rest }) => {
    const { setValue } = useFormContext();
    const sourceContext = useSourceContext();
    const src = sourceContext ? sourceContext.getSource : (s) => s;
   // console.log('index',scopedFormData)
    // if(!scopedFormData){
    //     return null
    // }
    return   <Fragment  >
        <Grid container spacing={2}>
            <Grid item>
                <SelectInput {...rest} onChange={ev=>{
                    const relation= familyRelationshipData.find(e=>e.id===ev.target.value)
                    if(relation) {
                        setValue(src("gender"), relation.gender)
                    }
                }} fullWidth label="Relationship" source="relationship" choices={familyRelationshipData} />

            </Grid>
            <Grid item>
                <TextInput  label="First Name" source="name" />

            </Grid>
            <Grid item>
                <TextInput  label="Father Name"  source="fatherName"  />

            </Grid>
        </Grid>

        <BooleanInput  defaultValue={false} label="Is Not Alive" source="notAlive" />


        {(!scopedFormData || !scopedFormData.notAlive) &&
        <>

            <Grid container spacing={2} style={{width:"100%"}}>

                <SelectInput {...rest} fullWidth label="Gender" source="gender" choices={[
                    {id: "Male", name: 'Male'},
                    {id: "Female", name: 'Female'},
                ]}/>
                <NumberInput {...rest}
                             defaultValue={moment().get('year') - moment(scopedFormData && scopedFormData.birthDate).get('year')}
                             onChange={ev => {
                                 const dob = moment()
                                 dob.add(-(+ev.target.value), 'year')
                                 setValue(src("birthDate"), dob.toDate().toDateString())
                             }} label="Age" source="age"/>

                {/*<DateInput {...rest} onChange={ev => {*/}
                {/*    const dob = moment(ev.target.value)*/}
                {/*    setValue(getSource("age"), moment().get('year') - dob.get('year'))*/}
                {/*}} label="Birth Date" source="birthDate" options={{*/}
                {/*    format: 'DD/MM/YYYY',*/}
                {/*    inputVariant: "filled",*/}
                {/*    views: ["year", "month", "date"],*/}
                {/*    autoOk: true,*/}
                {/*    openTo: "year"*/}
                {/*}}/>*/}


                {/*<DateInput label="Birth Date" source="birthDate" options={{ format: 'DD/MM/YYYY' }} style={{ display: 'inline', float: 'left', marginLeft: '20px' }}/>*/}
            </Grid>
            <EthiopianDateInput {...rest} onChange={ev => {
                // console.log(ev)
                const dob = moment(ev)

                setValue(src("age"), moment().get('year') - dob.get('year'))
            }} label="Birth Date" source="birthDate" />
            <ImageInput  format={ formatPic } source="photo" label="Photo" accept={{ 'image/*': [] }} placeholder={<p>Drop your file here</p>}>
                <ImageField source="src" title="title" />
            </ImageInput>

            <Typography  variant="h6" gutterBottom>Address</Typography>
            <ArrayInput  label='Phone'  source="address.phones">
                <SimpleFormIterator  >
                    <SelectInput defaultValue={'Mobile'} label="Type"  source="phoneType" choices={[
                        {id: "Mobile", name: 'Mobile'},
                        {id: "Home", name: 'Home'},
                        {id: "Office", name: 'Office'},
                    ]}/>

                    <TextInput label="Number"  source="number" />
                </SimpleFormIterator>
            </ArrayInput>
            <Typography   variant="h6" gutterBottom>Income</Typography>
            {/*<Box display="flex" style={{width:"100%"}}>*/}
            <TextInput label="Profession"  source="profession" />
            <NumberInput label="Salary /Monthly Income"  source="monthlyIncome"/>
            <BooleanInput  defaultValue={false} label="isIncomeProvider" source="isIncomeProvider" />
            {/*</Box>*/}


            <Typography  variant="h6" gutterBottom>Education</Typography>
            <Grid container style={{width:"100%"}}  >
                <Grid item md={2}>
                    <SelectInput label="Last Education Level"  source="currentEducation.level" choices={[
                        {id: "None", name: 'None'},
                        {id: "Kindergarten", name: 'Kindergarten'},
                        {id: "Elementary", name: 'Elementary'},
                        {id: "High School", name: 'High School'},
                        {id: "Higher Education", name: 'Higher Education'},
                        {id: "Other", name: 'Other'},
                    ]}/>
                </Grid>
                <Grid item md={2}>
                    <SelectInput label="Status"  source="currentEducation.status" choices={[
                        {id: "On Going", name: 'On Going'},
                        {id: "Completed", name: 'High School'},
                        {id: "Drop Out", name: 'Drop Out'},
                    ]}/>
                </Grid>
                <Grid item md={2}>

                    <SelectInput label="School Type"   source="currentEducation.schoolType" choices={[
                        {id: "Government", name: 'Government'},
                        {id: "Private", name: 'Private'},
                    ]}/>
                </Grid>
                <Grid item md={3}>
                    <TextInput label="School Name"  source="currentEducation.schoolName" />
                </Grid>
                <Grid item md={3}>
                    <TextInput label="Field"  source="currentEducation.field" />
                </Grid>
                <Grid item md={1}>
                    <NumberInput label="Grade"  source="currentEducation.grade" />
                </Grid>
                <Grid item md={2}>
                    <NumberInput label="Distance From home (km)"  source="currentEducation.distance" />
                </Grid>
            </Grid>
            <Typography  variant="h6" gutterBottom>Health</Typography>
            <SelectInput defaultValue={'Good'}  label="Health Condition"  source="health.generalCondition" choices={[
                {id: "Excellent", name: 'Excellent'},
                {id: "Good", name: 'Good'},
                {id: "Fair", name: 'Fair'},
                {id: "Poor", name: 'Poor'},
                {id: "Critical", name: 'Critical'},
            ]}/>
            <TextInput  label="Health Remark"  source="health.remark" />

        </>}
    </Fragment>
}
export const areasData = [
    { area: "4 Kilo", subCity: "Arada", woreda: "01", city: "Addis Ababa" },
    { area: "5 Kilo", subCity: "Arada", woreda: "02", city: "Addis Ababa" },
    { area: "6 Kilo", subCity: "Arada", woreda: "03", city: "Addis Ababa" },
    { area: "Akaki", subCity: "Akaki Kaliti", woreda: "01", city: "Addis Ababa" },
    { area: "Arat Kilo", subCity: "Arada", woreda: "04", city: "Addis Ababa" },
    { area: "Aware", subCity: "Yeka", woreda: "01", city: "Addis Ababa" },
    { area: "Ayat", subCity: "Lemi Kura", woreda: "13", city: "Addis Ababa" },
    { area: "Bethel", subCity: "Kolfe Keranyo", woreda: "11", city: "Addis Ababa" },
    { area: "Bisrate Gabriel", subCity: "Nifas Silk-Lafto", woreda: "03", city: "Addis Ababa" },
    { area: "Bole Arabsa", subCity: "Bole", woreda: "11", city: "Addis Ababa" },
    { area: "Bole Atlas", subCity: "Bole", woreda: "03", city: "Addis Ababa" },
    { area: "Bole Bulbula", subCity: "Bole", woreda: "12", city: "Addis Ababa" },
    { area: "Bole Medhanialem", subCity: "Bole", woreda: "03", city: "Addis Ababa" },
    { area: "Bole Michael", subCity: "Bole", woreda: "04", city: "Addis Ababa" },
    { area: "CMC", subCity: "Lemi Kura", woreda: "02", city: "Addis Ababa" },
    { area: "Gerji", subCity: "Bole", woreda: "11", city: "Addis Ababa" },
    { area: "Gotera", subCity: "Kirkos", woreda: "05", city: "Addis Ababa" },
    { area: "Gulele", subCity: "Gulele", woreda: "01", city: "Addis Ababa" },
    { area: "Gurd Shola", subCity: "Yeka", woreda: "07", city: "Addis Ababa" },
    { area: "Jemo", subCity: "Nifas Silk-Lafto", woreda: "01", city: "Addis Ababa" },
    { area: "Kality", subCity: "Akaki Kaliti", woreda: "03", city: "Addis Ababa" },
    { area: "Kasanchis", subCity: "Kirkos", woreda: "08", city: "Addis Ababa" },
    { area: "Kebena", subCity: "Yeka", woreda: "02", city: "Addis Ababa" },
    { area: "Keranyo", subCity: "Kolfe Keranyo", woreda: "06", city: "Addis Ababa" },
    { area: "Kolfe", subCity: "Kolfe Keranyo", woreda: "07", city: "Addis Ababa" },
    { area: "Kotebe", subCity: "Yeka", woreda: "10", city: "Addis Ababa" },
    { area: "Lafto", subCity: "Nifas Silk-Lafto", woreda: "02", city: "Addis Ababa" },
    { area: "Lebu", subCity: "Nifas Silk-Lafto", woreda: "01", city: "Addis Ababa" },
    { area: "Megenagna", subCity: "Yeka", woreda: "08", city: "Addis Ababa" },
    { area: "Mekanisa", subCity: "Nifas Silk-Lafto", woreda: "05", city: "Addis Ababa" },
    { area: "Merkato", subCity: "Addis Ketema", woreda: "01", city: "Addis Ababa" },
    { area: "Meskel Square", subCity: "Kirkos", woreda: "07", city: "Addis Ababa" },
    { area: "Old Airport", subCity: "Nifas Silk-Lafto", woreda: "05", city: "Addis Ababa" },
    { area: "Piazza", subCity: "Arada", woreda: "01", city: "Addis Ababa" },
    { area: "Piassa", subCity: "Arada", woreda: "01", city: "Addis Ababa" },
    { area: "Sarbet", subCity: "Nifas Silk-Lafto", woreda: "06", city: "Addis Ababa" },
    { area: "Saris", subCity: "Nifas Silk-Lafto", woreda: "10", city: "Addis Ababa" },
    { area: "Shiro Meda", subCity: "Gulele", woreda: "08", city: "Addis Ababa" },
    { area: "Summit", subCity: "Lemi Kura", woreda: "06", city: "Addis Ababa" },
    { area: "Tor Hailoch", subCity: "Kolfe Keranyo", woreda: "09", city: "Addis Ababa" },
    { area: "Urael", subCity: "Bole", woreda: "05", city: "Addis Ababa" },
    { area: "Wosen", subCity: "Yeka", woreda: "12", city: "Addis Ababa" },
];

const subCitiesData = [
    { id: "Addis Ketema", name: "Addis Ketema" },
    { id: "Akaki Kaliti", name: "Akaki Kaliti" },
    { id: "Arada", name: "Arada" },
    { id: "Bole", name: "Bole" },
    { id: "Gullele", name: "Gullele" },
    { id: "Kirkos", name: "Kirkos" },
    { id: "Kolfe Keranio", name: "Kolfe Keranio" },
    { id: "Lideta", name: "Lideta" },
    { id: "Lemi Kura", name: "Lemi Kura" },
    { id: "Nifas Silk-Lafto", name: "Nifas Silk-Lafto" },
    { id: "Yeka", name: "Yeka" },
];

const AreaAutocompleteInput = (props) => {
    const { setValue, getValues } = useFormContext();
    const value = getValues(props.source) || '';

    return (
        <Autocomplete
            freeSolo
            fullWidth
            value={value}
            options={areasData.map(a => a.area)}
            onChange={(event, newValue) => {
                const val = newValue || '';
                setValue(props.source, val, { shouldDirty: true });
                const areaItem = areasData.find(a => a.area === val);
                if (areaItem) {
                    setValue('place.address.city', areaItem.city, { shouldDirty: true });
                    setValue('place.address.subcity', areaItem.subCity, { shouldDirty: true });
                    setValue('place.address.woreda', areaItem.woreda, { shouldDirty: true });
                }
            }}
            onInputChange={(event, newInputValue) => {
                setValue(props.source, newInputValue, { shouldDirty: true });
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    name={props.source}
                    label={props.label}
                    placeholder="The common name of the area or sefer"
                    variant="filled"
                    sx={{ mb: 2 }}
                />
            )}
        />
    );
};

export const PlaceFormContent = props => {
    const { setValue } = useFormContext();
    const orphanages = [
        { name: 'Zewditu', id: 'Zewditu', address:{city:"Addis Ababa", subcity:"Gullele", houseNumber:"", woreda:"", locationText:"Qusquam Mariam, Entoto near to Entoto Park shiromeda gate"}, photo:"http://res.cloudinary.com/finado/image/upload/v1621326799/photos/fmo1dbjgxznrekhewxkz.jpg" },
     //   { name: 'Other', id: 'Other', address:{city:"Addis Ababa", subcity:"Gullele", houseNumber:"", woreda:"", locationText:"Qusquam Mariam, Entoto near to Entoto Park shiromeda gate"}, photo:"" },

    ];
    return   <>

        <SelectInput label="Place Type"  source="place.type" choices={[
            {id: "Rental", name: 'Rental'},
            {id: "Private", name: 'Private'},
            {id: "Kebele", name: 'Kebele'},
            {id: "Orphanage", name: 'Orphanage'},
        ]}/>
        {props.formData && props.formData.place && props.formData.place.type ==='Orphanage' && <AutocompleteInput allowEmpty source="place.name" label="Place Name" choices={orphanages}  onCreate={() => {
            const newCategoryName = prompt('Enter a new Place');
            const newCategory = { id: newCategoryName.toLowerCase(), name: newCategoryName };
            orphanages.push(newCategory);
            return newCategory;
        }} onChange={id=>{
            const item = orphanages.find(o=>o.id===id)
            if(item){
                setValue('place.address',item.address)
                setValue('place.photo',item.photo)
            }

        }} />}

        <AreaAutocompleteInput label="Area" source="place.address.area" />

        <TextInput label="City"  source="place.address.city" />
        <SelectInput label="Sub City" source="place.address.subcity" choices={subCitiesData} />
        <TextInput label="Woreda"  source="place.address.woreda" />
        <TextInput label="House Number"  source="place.address.houseNumber" />
        <TextInput label="Location Text"  source="place.address.locationText" />
        <ImageInput format={ formatPic } source="place.photo" label="Picture" accept={{ 'image/*': [] }} placeholder={<p>Drop your file here</p>}>
            <ImageField source="src" title="title" />
        </ImageInput>
        <TextInput label="Remark"  source="place.address.remark" />

    </>
}

export const PlaceForm = props => {
    return <FormTab {...props} label="Place">
        <PlaceFormContent {...props}/>
    </FormTab>
}
export const PersonalFormContent = props => {
    const { setValue } = useFormContext();
    const {formData} = props;


    return  <>

        <TextInput label="First Name" source="name" style={{ display: 'inline', float: 'left'}} validate={[required()]} />
        <TextInput label="Father Name"  source="fatherName" style={{ display: 'inline', float: 'left', marginLeft: '20px' } } validate={[required()]} />
        <TextInput label="Grand Father Name" source="gFatherName" />
        <SelectInput source="gender" fullWidth choices={[
            {id: "Male", name: 'Male'},
            {id: "Female", name: 'Female'},
        ]} style={{ display: 'inline', width:"25%", float: 'left'}}/>

  <NumberInput source='age' onChange={ev=>{
      const dob = moment("2021-01-01")
      dob.add(-(+ev.target.value), 'year')
      setValue("birthDate", dob.toDate().toDateString())
  }} />

        {/*<DateInput source="birthDate"  options={{ format: 'DD/MM/YY' }} style={{ display: 'inline', width:"25%", float: 'left'}} />*/}
   <EthiopianDateInput label="Birth Date" source="birthDate" onChange={ev=>{
       const dob = moment(ev)

       setValue("age", moment().get('year') - dob.get('year'))
   }} />

       {/*<AutocompleteInput source="placeOfBirth" choices={[*/}
        {/*    { id: 'Addis Ababa', name: 'Addis Ababa' },*/}
        {/*   ]} />*/}
        <TextInput defaultValue="Addis Ababa"  source="placeOfBirth" />
        {/*<DateTimeInput source="birthDate"  options={{ format: 'DD/MM/YYYY' }}  />*/}
        <ImageInput format={ formatPic } source="photo" label="Photo" accept={{ 'image/*': [] }} placeholder={<p>Drop your file here</p>}>
            <ImageField source="src" title="title" />
        </ImageInput>

        <Typography variant="h6" gutterBottom>Health</Typography>
        {/*<TextInput label="Health Condition"  source="health.generalCondition" />*/}
        <Box display="flex" style={{width:"100%"}}>
            <Box flex={3} mr="0.5em">
                <SelectInput defaultValue={'Good'} label="Health Condition"  source="health.generalCondition" choices={[
                    {id: "Excellent", name: 'Excellent'},
                    {id: "Good", name: 'Good'},
                    {id: "Fair", name: 'Fair'},
                    {id: "Poor", name: 'Poor'},
                    {id: "Critical", name: 'Critical'},
                ]}/>
            </Box>
            <Box flex={9} ml="0.5em">
                <TextInput multiline fullWidth  label="Health Remark"  source="health.remark" />
            </Box>
        </Box>


        <Typography variant="h6" gutterBottom>Current Education</Typography>
        <Grid container style={{width:"100%"}}  >
            <Grid item md={3}>
                <SelectInput label="Education Level"  source="currentEducation.level" choices={[
                    {id: "None", name: 'None'},
                    {id: "Kindergarten", name: 'Kindergarten'},
                    {id: "Elementary", name: 'Elementary'},
                    {id: "High School", name: 'High School'},
                    {id: "Higher Education", name: 'Higher Education'},
                    {id: "Other", name: 'Other'},
                ]}/>
            </Grid>
            <Grid item md={2}>

                <SelectInput label="School Type"   source="currentEducation.schoolType" choices={[
                    {id: "Government", name: 'Government'},
                    {id: "Private", name: 'Private'},
                ]}/>
            </Grid>
            <Grid item md={3}>
                <TextInput label="School Name"  source="currentEducation.schoolName" />
            </Grid>
            {(formData?.currentEducation?.level==="Higher Education"||formData?.currentEducation?.level==="Other")&&<Grid item md={3}>
                <TextInput label="Field" source="currentEducation.field"/>
            </Grid>}
            {(formData?.currentEducation?.level==="Higher Education"||formData?.currentEducation?.level==="Other")&&<Grid>
                <NumberInput label="Study Duration" source="currentEducation.studyDuration"/>
            </Grid>}
            {(formData?.currentEducation?.level==="Higher Education"||formData?.currentEducation?.level==="Other")&&<Grid>
                <Grid item md={2}>

                    <SelectInput label="Qualification Level"   source="currentEducation.qualificationLevel" choices={[
                        {id: "Certificate", name: 'Certificate'},
                        {id: "Diploma", name: 'Diploma'},
                        {id: "Degree", name: 'Degree'},
                        {id: "Masters", name: "Master's"},
                        {id: "Doctorate", name: 'Doctorate'},
                    ]}/>
                </Grid>
            </Grid>}
            {(formData?.currentEducation?.level==="Higher Education"||formData?.currentEducation?.level==="Other")&&<Grid>
                <Grid item md={2}>

                    <SelectInput label="Duration Period"   source="currentEducation.durationPeriod" choices={[
                        {id: "Month", name: 'Month'},
                        {id: "Year", name: 'Year'},
                    ]}/>
                </Grid>
            </Grid>}
            <Grid item md={2}>
                <NumberInput label="Current Grade/Level"  source="currentEducation.grade" />
            </Grid>
            <Grid item md={2}>
                <NumberInput label="Distance From home (km)"  source="currentEducation.distance" />
            </Grid>
        </Grid>
        <Typography  variant="h6" gutterBottom>Contact Info</Typography>


        <ArrayInput  label='Phones' source="address.phones">
            <SimpleFormIterator  >
                <TextInput label="Number"  source="number" />
            </SimpleFormIterator>
        </ArrayInput>
        <TextInput label='Email' source='address.email'/>

    </>
}
export  const PersonalForm = props => {
    return  <FormTab {...props}  label="Personal">
        <PersonalFormContent {...props}/>
    </FormTab>
}
export const StoryContent = props => {
    return  <>
        <RichTextInput label="Story"  source="story.story" />
        <TextInput label="Wants to be" source="story.dream"/>

        <ArrayInput label='Attachments'  source="story.files">
            <SimpleFormIterator  >
                {/*<TextInput source="filePath" />*/}
                <FileInput source="filePath" label="File"  placeholder={<p>Drop your file here</p>}>
                    <FileField source="src" title="title" />
                </FileInput>
                <SelectInput label="Type"  source="type" choices={[
                    {id: "SubcityFile", name: 'Subcity File'},
                    {id: "Certificate", name: 'School Certificate'},
                    {id: "Other", name: 'Other'},
                ]}/>

                <TextInput label='Title' source="title" />
                <DateInput label='Date' source="date"  options={{ format: 'DD/MM/YYYY' }}/>
                <TextInput multiline label='Description' source="description" />



            </SimpleFormIterator>
        </ArrayInput>
        <ArrayInput label='Photos'  source="story.photos">
            <SimpleFormIterator  >
                {/*<TextInput source="filePath" />*/}
                <ImageInput format={ formatPic } source="filePath" label="Photo" accept={{ 'image/*': [] }} placeholder={<p>Drop your file here</p>}>
                    <ImageField source="src" title="title" />
                </ImageInput>

                    <TextInput label='Title' source="title" />
                    <DateInput label='Date' source="date"  options={{ format: 'DD/MM/YYYY' }}/>
                    <TextInput multiline label='Description' source="description" />



            </SimpleFormIterator>
        </ArrayInput>

        {/*<BooleanInput label="Government Approved" source="story.governmentApproved" />*/}
    </>
}
export const StoryFrom = props => {
    return  <FormTab {...props}   label="Story">
        <StoryContent {...props}/>
    </FormTab>
}

// A Record search input that filters the loaded choices on the client side as
// the user types (the backend only supports exact-match filters, so server
// side autocomplete filtering would never narrow the list for partial input).
// The option label concatenates the registration id with the full name so a
// single field can be searched by either. Selecting a record sets `source`
// (e.g. "_id" or "record") on the list filter, applied by react-admin's <Filter>.
export const RecordAutocompleteInput = ({ source, label, emptyText, ...rest }) => {
    const { data } = useGetList('Record', {
        pagination: { page: 1, perPage: 1000 },
    });
    const choices = data || [];

    const optionText = (record) =>
        `${record.registrationId || ''} - ${record.name || ''} ${
            record.fatherName || ''
        }`.trim();

    const matchSuggestion = (filterValue, choice) => {
        const fv = (filterValue || '').trim().toLowerCase();
        if (!fv) return true;
        const text = optionText(choice).toLowerCase();
        return text.includes(fv);
    };

    return (
        <AutocompleteInput
            source={source}
            label={label}
            choices={choices}
            optionValue="id"
            optionText={optionText}
            matchSuggestion={matchSuggestion}
            allowEmpty
            emptyText=""
            style={{ minWidth: 360 }}
            {...rest}
        />
    );
};
